module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-preface element-without-heading",
    attrs: {
      "id": "preface"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "preface-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('i', [_vm._v("The builders did bow before the castle lord and say to him that his fortress was complete. But the lord declared the castle not yet strong enough, for his enemies were powerful and many. And so the lord commanded the builders to set an iron ring into the stone on the battlements at each compass point of the keep, and he chose his four strongest warriors to sanctify his fortress with their lives. One of the four was chained to each of the rings and charged to watch for marauders who might appear from any point along the sweeping horizon. At every hour the watch bells were rung to ensure the warriors did not sleep, and none were allowed to speak to them lest they be distracted from their duty. Through burning autumn and into bitter winter the four stood watch, allowed no shelter, no comfort, and no respite, believing that their faithfulness and honor would protect their lord’s stronghold long after their eyes and ears had failed. And when they died, they were left in place until their dust had filtered into the stones and mortar. They were called the Guardians of the Keep and are said to protect it still, and the symbol of the Four Guardian Rings is the shield of Comigor. Indeed, the four were potent warriors, for never in six hundred years has Comigor fallen to its enemies.")])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-right"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("—The History and Legends of Comigor Castle")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4559a71a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface.vue
// module id = 75
// module chunks = 0